import SEO from "@/components/SEO";
import { PageHero, Section, SectionHead, NumberedList } from "@/components/sections";
import { Reveal } from "@/components/Reveal";
import { CTALink, Stat } from "@/components/ui-kit";

const approach = [
  { title: "Plan-first, always", body: "Before any product, we understand your goals, cash flows, obligations and risk appetite. The plan drives every recommendation." },
  { title: "One advisor, the full picture", body: "Investments, insurance, credit and, for businesses, treasury — coordinated through a single relationship so nothing falls between the cracks." },
  { title: "Scheduled reviews, not abandonment", body: "We build a review calendar into the relationship. Your plan is maintained through market cycles and life events, not sold once and forgotten." },
  { title: "Plain-spoken and compliant", body: "No jargon, no hype, no guaranteed-return promises. Just clear trade-offs, potential outcomes and honest risk." },
];

const roles = ["Sharekhan", "Motilal Oswal", "Angel One", "Bonds Bazaar"];

export default function About() {
  return (
    <div>
      <SEO path="/about" title="About Karthik Rao" description="Karthik Rao — MBA (SIMSREE), B.Com Financial Markets, 9+ years in financial services. The plan-first, one-advisor approach behind Rao Investment Solutions." />
      <PageHero
        label="About"
        title="An advisor who plans first, and stays for the reviews."
        intro="Rao Investment Solutions is built on a simple belief: advice should serve the plan, and the plan should serve you."
        breadcrumbs={[{ name: "Home", to: "/" }, { name: "About" }]}
      />

      <Section>
        <div className="grid md:grid-cols-12 gap-12 items-start">
          <div className="md:col-span-8">
            <SectionHead label="Founder" title="Karthik Rao" intro="Wealth Manager and Broker Associate · MBA, SIMSREE · B.Com Financial Markets · 9+ years in financial services." />
            <div className="space-y-5 font-sans text-lg text-slate leading-relaxed">
              <p>Karthik has spent nine-plus years across the financial-services value chain — in wealth management and broking, across equities, bonds and mutual funds. That range is deliberate: it means advice here is informed by how products are really distributed, priced and serviced.</p>
              <p>He founded Rao Investment Solutions to bring that institutional discipline to businesses and families who want a single, honest point of contact for the whole financial picture.</p>
            </div>
            <div className="mt-8">
              <div className="font-sans text-xs uppercase tracking-[0.24em] text-slate mb-4">Experience</div>
              <div className="flex flex-wrap gap-2">
                {roles.map((r) => (
                  <span key={r} className="font-data text-sm text-navy border border-navy/15 px-4 py-2">{r}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Section>

      <Section cream>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <Stat value="9+" label="Years experience" />
          <Stat value="MBA" label="SIMSREE" />
          <Stat value="AMFI" label="Registered distributor · ARN-261755" />
          <Stat value="1:1" label="Relationship led" />
        </div>
      </Section>

      <Section dark>
        <SectionHead label="Our approach" title="How we work" dark />
        <NumberedList items={approach} dark />
        <div className="mt-12">
          <CTALink to="/contact" variant="primary" data-testid="about-contact-cta">Start a conversation</CTALink>
        </div>
      </Section>
    </div>
  );
}
